import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        bankAccountBankName: undefined,
        bankAccountIban: undefined,
        bankAccountOwner: undefined,
        bankDetailsTermsAccepted: false,
        bankAccountDirectDebitAuthorisationText: undefined,
    },
    mutations: {
        setCollectedData: (state, payload) => {
            Vue.set(
                state,
                payload.field,
                payload.value,
            );
        },
        deleteCollectedData: (state, field) => {
            Vue.delete(
                state,
                field,
            );
        },
    },
};
